import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import PerPageOptionComponent from './perPageOption.component';
import PageNavComponent from './pageNav.component';
import './brPaginatorV2.scss';

export default class BrPaginatorV2 extends PureComponent {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    numPerPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    perPageOptions: PropTypes.arrayOf(PropTypes.number),
    onChangePage: PropTypes.func.isRequired,
    onChangeNumPerPage: PropTypes.func,
    displayText: PropTypes.string,
    skipAutoPageNumUpdate: PropTypes.bool,
  };

  static defaultProps = {
    perPageOptions: [10, 20, 50, 100],
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    // setState -> no rerender
    // this step is will not be invoked by this.setState
    // reset the page to first page if numPerPage changed
    if (nextProps.numPerPage !== this.props.numPerPage && !this.props.skipAutoPageNumUpdate) {
      this.props.onChangePage(1);
    }
  }

  render() {
    // eslint-disable-next-line max-len
    const { currentPage, numPerPage, totalCount, perPageOptions, onChangePage, onChangeNumPerPage, displayText } = this.props;
    const startIdx = (currentPage - 1) * numPerPage + 1;
    const endIdx = Math.min(startIdx + numPerPage - 1, totalCount);
    const totalPage = Math.max(1, Math.ceil(totalCount / numPerPage));
    return (
      <div className="br-paginator-v2" data-id="br-paginator">
        {onChangeNumPerPage && (
          <PerPageOptionComponent
            selectedOption={numPerPage}
            perPageOptions={perPageOptions}
            onChangeNumPerPage={onChangeNumPerPage}
            displayText={displayText}
          />
        )}
        <div className="paginator-count">
          <div>
            {startIdx}
            {' - '}
            {endIdx}
            {' of '}
            {totalCount}
          </div>
        </div>
        <div className="paginator-nav">
          <PageNavComponent currentPage={currentPage} totalPage={totalPage} onChangePage={onChangePage} />
        </div>
      </div>
    );
  }
}
